import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Input,
  Form,
  Upload,
  Icon,
  message,
  Checkbox,
  Radio,
  Button,
  Select,
  Divider,
  Modal,
} from 'antd';

import _ from 'lodash';
import { Link } from 'react-router-dom';
import ModalConfirmation from 'components/ModalConfirmation/ModalConfirmation.component';
import { handleUpload, fileUploaderService } from 'shared/utils/FilesUtil';
import { formatMoney } from 'shared/utils/StringUtil';
import { amountInput, reformatNum } from 'shared/utils/FormUtil';
import { permissionService } from 'shared/services';
import get from 'lodash/get';
import billerRoute from '../../route';
import text from './BillerForm.components.translation';

import './BillerForm.style.less';

const { Option } = Select;
const { confirm } = Modal;
const { checkPermission } = permissionService;
const { TextArea } = Input;

class FormBillerCreate extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      serviceIcon: {
        imageUrl: [],
        loading: false,
      },
      serviceBanner: {
        imageUrl: [],
        loading: false,
        previewImage: '',
        isPreview: false,
        selectedImage: {},
      },
      billerDetail: {
        id: '',
        public_id: '',
        name: '',
        icon_abs_url: '',
        banner_abs_url: '',
        va_prefix: [],
        service: {
          id: props.billerDetail.serviceId || '',
        },
        form: {},
        pground_status: 3,
        skyw_status: 3,
        archived_at: '',
        created_at: '',
        updated_at: '',
        biller_type: '',
      },
      isArchive: false,
      proceedArchive: false,
      modalConfirm: {
        visible: false,
        content: '',
        cancelText: 'Cancel',
        okText: 'Ok',
        onCancel: () => {},
        onProceed: () => {},
        confirmType: '',
      },
      billerTypeInterpret: {
        1: 'fixed',
        2: 'flexible',
      },
      bodyParam: {},
      syncModalVisible: false,
      syncConsent: false,
      searchTnc: '',
    };

    this.selectedPaymentMethod = [];

    this.selectServiceRef = React.createRef();
    this.selectFormRef = React.createRef();
    this.selectTnCRef = React.createRef();
  }

  componentDidMount() {
    const { formType, billerDetail } = this.props;
    const { billerTypeInterpret } = this.state;
    // Set Porps to State
    if (formType === 'edit') {
      const serviceIcon = {
        imageUrl: [],
        loading: false,
      };
      serviceIcon.imageUrl.push({ url: billerDetail.icon_abs_url });
      const serviceBanner = {
        imageUrl: [],
        loading: false,
      };

      const filest = _.get(billerDetail, 'banner_abs_url', []);
      filest.forEach(url => {
        // get file name
        const fileName = url.split('/').pop();
        serviceBanner.imageUrl.push({
          uid: `${url}-xx`,
          name: fileName,
          status: 'done',
          url,
        });
      });

      // Custom Update Biller State
      const newBillerDetail = { ...billerDetail };
      newBillerDetail.biller_type =
        billerTypeInterpret[billerDetail.biller_type] || '';

      // set default selected payment method
      this.selectedPaymentMethod = _.get(billerDetail, 'payment_method') || [];

      this.setState({
        serviceIcon,
        serviceBanner,
        billerDetail: newBillerDetail,
        isArchive: !!billerDetail.archived_at,
      });
    }
  }

  showBeneficiaryBank = () => {
    const { billerDetail } = this.state;
    if (billerDetail.biller_type === 'fixed') {
      return false;
    }
    return true;
  };

  // Convert To Base64 Promise
  getBase64Image = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  selectionFilter = (input, option) =>
    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  billerEditSubmit = val => {
    const { serviceBanner, serviceIcon, isArchive } = this.state;
    const currArchive = !!this.props.billerDetail.archived_at;
    const lastIcon = serviceIcon.imageUrl.length - 1;

    const bodyParam = {
      name: val.biller_name,
      icon_abs_url: serviceIcon.imageUrl[lastIcon].url,
      banner_abs_url: serviceBanner.imageUrl.map(item => item.url),
      service_id: val.service_id,
      form_id: val.related_form || '',
      pground_status: val.playground_status,
      skyw_status: val.skywallker_status,
      biller_type: val.biller_type === 'fixed' ? 1 : 2,
      beneficiary_bank_id: val.bank_id,
      archiveChange: currArchive !== isArchive,
      transaction_fee: reformatNum(val.transactionFee),
      payment_method: this.selectedPaymentMethod,
      tnc_public_id: val.tnc || '',
    };
    // Checking IF Archiving Change
    if (isArchive !== currArchive) {
      this.confirmArchiving(bodyParam);
    } else {
      this.props.onSubmit(bodyParam, this.state.syncConsent);
    }
  };

  billerAddSubmit = val => {
    const { serviceBanner, serviceIcon } = this.state;
    const lastIcon = serviceIcon.imageUrl.length - 1;
    const bodyParam = {
      name: val.biller_name,
      icon_abs_url: serviceIcon.imageUrl[lastIcon].url,
      banner_abs_url: serviceBanner.imageUrl.map(item => item.url),
      pground_status: val.playground_status,
      skyw_status: val.skywallker_status,
      service_id: val.service_id,
      form_id: val.related_form,
      biller_type: val.biller_type === 'fixed' ? 1 : 2,
      beneficiary_bank_id: val.bank_id,
      transaction_fee: reformatNum(val.transactionFee),
      payment_method: this.selectedPaymentMethod,
      tnc_public_id: val.tnc || '',
    };

    this.props.onSubmit(bodyParam, this.state.syncConsent);
  };

  handleCancelPreview = () => {
    const { serviceBanner } = this.state;
    this.setState({
      serviceBanner: {
        ...serviceBanner,
        isPreview: false,
      },
    });
  };

  handlePreviewBanner = async file => {
    const { serviceBanner } = this.state;
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64Image(file.originFileObj);
    }
    this.setState({
      serviceBanner: {
        imageUrl: serviceBanner.imageUrl,
        previewImage: file.url || file.preview,
        isPreview: true,
        selectedImage: file,
      },
    });
  };

  _onOk = file => {
    const { serviceBanner } = this.state;
    this.setState(
      {
        serviceBanner: {
          ...serviceBanner,
          imageUrl: serviceBanner.imageUrl.filter(
            item => item.uid !== file.uid,
          ),
        },
      },
      () => {
        if (serviceBanner.imageUrl.length <= 0) {
          this.props.form.setFieldsValue({
            serviceBanner: undefined,
          });
        }
      },
    );
  };

  handleRemoveBanner = file => {
    this.handleCancelPreview();
    setTimeout(() => {
      confirm({
        title: 'Remove Banner',
        content: 'are you sure will remove this banner?',
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        cancelButtonProps: 'btn-cancel',
        onOk: () => this._onOk(file),
      });
    }, 200);
  };

  fileUpload = formName => file => {
    fileUploaderService(file, this.onActionUploadService(formName));
  };

  onActionUploadService = formName => (res, fileInfo, status) => {
    if (status === 'success') {
      message.success({
        content: 'Image Success Upload',
        key: 'imageUpload',
      });
      const fileList = {
        uid: fileInfo.uid,
        name: fileInfo.fileName,
        status: 'done',
        url: res.data.payload.abs_path_url,
      };
      const getState = this.state;
      const stateImageList = [...getState[formName].imageUrl];
      stateImageList.push(fileList);

      this.setState({
        [formName]: {
          imageUrl: stateImageList,
          isPreview: false,
          loading: false,
        },
      });
    } else {
      this.props.form.setFieldsValue({
        [formName]: undefined,
      });
      message.error({
        content: 'Failed Upload Image!',
        key: 'imageUpload',
      });
    }
  };

  fileUploadInvalid = formName => () => {
    const { imageUrl } = this.state[formName];
    const formValue = {
      value: null,
      errors: [new Error('Invalid file')],
    };
    if (imageUrl.length > 0) {
      formValue.value = imageUrl;
    }
    this.props.form.setFields({
      [formName]: formValue,
    });
  };

  _renderServiceIconUpload = () => {
    const { serviceIcon } = this.state;
    const uploadConfig = {
      maxSize: 100,
      maxDimension: {
        width: 192,
        height: 192,
        exact: true,
      },
    };
    const props = {
      name: 'service-icon',
      listType: 'picture-card service-icon',
      multiple: false,
      fileList: false,
      showUploadList: false,
      beforeUpload: () => false,
      onChange: handleUpload(
        uploadConfig,
        this.fileUpload('serviceIcon'),
        this.fileUploadInvalid('serviceIcon'),
      ),
    };

    return (
      <Upload {...props}>
        {serviceIcon.imageUrl.length < 1 ? (
          <div>
            <Icon type={serviceIcon.loading ? 'loading' : 'plus'} />
          </div>
        ) : (
          <img
            src={serviceIcon.imageUrl[serviceIcon.imageUrl.length - 1].url}
            alt="avatar"
            style={{ width: '100%' }}
          />
        )}
      </Upload>
    );
  };

  _renderServiceBannerUpload = () => {
    const { serviceBanner } = this.state;
    const uploadConfig = {
      maxSize: 100,
      maxDimension: {
        width: 375,
        height: 96,
        exact: true,
      },
    };
    const props = {
      name: 'service-banner',
      listType: 'picture-card',
      className: 'service-banner',
      fileList: serviceBanner.imageUrl,
      showUploadList: {
        showPreviewIcon: true,
        showDownloadIcon: false,
        showRemoveIcon: true,
      },
      beforeUpload: () => false,
      onChange: handleUpload(
        uploadConfig,
        this.fileUpload('serviceBanner'),
        this.fileUploadInvalid('serviceBanner'),
      ),
      onPreview: this.handlePreviewBanner,
      onRemove: this.handleRemoveBanner,
    };
    return (
      <Upload {...props}>
        {serviceBanner.imageUrl.length < 3 ? (
          <div>
            <Icon type={serviceBanner.loading ? 'loading' : 'plus'} />
          </div>
        ) : null}
      </Upload>
    );
  };

  _renderCreatedAndUpdatedDate = (created, updated, formType) => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    if (formType === 'edit') {
      return (
        <div>
          {checkPermission('Biller:update', true) && (
            <Form.Item extra="By archiving this biller is considered no longer active for any service">
              {getFieldDecorator('archive', {
                initialValue: this.state.isArchive,
              })(
                <Checkbox
                  checked={this.state.isArchive}
                  onChange={this._onChangeArchive}
                  className="display-block"
                >
                  Archive
                </Checkbox>,
              )}
            </Form.Item>
          )}
          <Form.Item label="Created At" colon={false}>
            {getFieldDecorator('created_at', {
              initialValue: created,
            })(<Input disabled size="large" />)}
          </Form.Item>

          <Form.Item label="Updated At" colon={false}>
            {getFieldDecorator('updated_at', {
              initialValue: updated,
            })(<Input disabled size="large" />)}
          </Form.Item>
        </div>
      );
    }

    return null;
  };

  _renderRadioPlayGroundStatus = () => (
    <Radio.Group>
      <Radio value={3}>Hidden</Radio>
      <Radio value={2}>Active</Radio>
      <Radio value={1}>Inactive</Radio>
    </Radio.Group>
  );

  _renderRadioSkyWallkerStatus = () => (
    <Radio.Group>
      <Radio value={3}>Hidden</Radio>
      <Radio value={2}>Active</Radio>
      <Radio value={1}>Inactive</Radio>
    </Radio.Group>
  );

  _onChangeArchive = () => {
    const { isArchive } = this.state;
    this.setState({
      isArchive: !isArchive,
    });
  };

  _onArchive = () => {
    this.closeConfirm();

    this.props.onArchive(this.state.syncConsent);
  };

  confirmArchiving = bodyParam => {
    const { isArchive } = this.state;
    const archivingText = `${isArchive ? 'Archive' : 'unArchive'}`;
    const makeContent = (
      <p>
        Are you sure want to <b>{archivingText}</b> this billers? (All billers
        under this billers will be archived and set to default status)
      </p>
    );
    const modalConfirm = {
      visible: true,
      content: makeContent,
      cancelText: 'Cancel',
      okText: archivingText,
      onCancel: this.closeConfirm,
      onProceed: this._onArchive,
      confirmType: '',
    };
    this.setState({
      modalConfirm,
      bodyParam,
    });
  };

  closeConfirm = () => {
    const { modalConfirm } = this.state;
    const newState = { ...modalConfirm };
    newState.visible = false;
    this.setState({
      modalConfirm: newState,
    });
  };

  modalCallBackSuccess = () => {
    const { bodyParam } = this.state;
    this.props.onSubmit(bodyParam);
  };

  _renderModalPreviewBanner() {
    const { serviceBanner } = this.state;
    const { selectedImage } = serviceBanner;
    return (
      <Modal
        visible={serviceBanner.isPreview}
        footer={null}
        closable={false}
        title="Preview Banner"
        className="modal-preview-banner"
      >
        <Row>
          <img
            alt="example"
            className="preview-img-banner"
            src={serviceBanner.previewImage}
          />
        </Row>
        <Row className="btn-group-wrapper">
          <center>
            <Button className="btn-cancel" onClick={this.handleCancelPreview}>
              Cancel
            </Button>
            <Button
              className="btn-delete"
              type="danger"
              onClick={() => this.handleRemoveBanner(selectedImage)}
            >
              Delete
            </Button>
          </center>
        </Row>
      </Modal>
    );
  }

  createNewFormElementServiceList = menu => (
    <div>
      {menu}
      <Divider style={{ margin: '4px 0' }} />
      <Link to={billerRoute.SERVICES_CREATE}>
        <div className="add-new-form" onMouseDown={e => e.preventDefault()}>
          <Icon type="plus" /> Create New Service
        </div>
      </Link>
    </div>
  );

  handleSearch = type => value => {
    const defaultParam = `page_num=1&page_size=50&name=${value}`;
    if (type === 'service') {
      this.props.getListService(defaultParam);
    } else if (type === 'related') {
      this.props.getListForm(defaultParam);
    } else {
      this.props.getListTnc('page_num=1&page_size=50', `&name=${value}`);
      this.setState({ searchTnc: value });
    }
  };

  onSelectOption = node => () => {
    node.blur();
  };

  _renderServiceList = () => {
    const { listService } = this.props;
    const listSelection = listService.map(item => ({
      value: item.id,
      name: `${item.public_id} - ${item.name}`,
    }));
    return (
      <Select
        showSearch
        placeholder="Choose Service Name"
        optionFilterProp="children"
        onSearch={this.handleSearch('service')}
        onFocus={() => {
          this.handleSearch('')('service');
        }}
        filterOption={this.selectionFilter}
        dropdownRender={this.createNewFormElementServiceList}
        size="large"
        loading={this.props.loading}
        notFoundContent={null}
        onSelect={this.onSelectOption(this.selectServiceRef.current)}
        ref={this.selectServiceRef}
      >
        {this.optionRender(listSelection)}
      </Select>
    );
  };

  createNewFormElementRelatedForm = menu => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div>
        {menu}
        <Divider style={{ margin: '4px 0' }} />
        <Link to={billerRoute.FORM_BUILDERS}>
          <div className="add-new-form" onMouseDown={e => e.preventDefault()}>
            <Icon type="plus" /> {formatMessage(text.createBillerForm)}
          </div>
        </Link>
      </div>
    );
  };

  _renderSearchRelatedForm = () => {
    const { listForm } = this.props;
    const listSelection = listForm.map(item => ({
      value: item.id,
      name: `${item.public_id} - ${item.name}`,
    }));
    return (
      <Select
        showSearch
        placeholder="Search related form"
        optionFilterProp="children"
        onSearch={this.handleSearch('related')}
        onFocus={() => {
          this.handleSearch('')('related');
        }}
        filterOption={this.selectionFilter}
        dropdownRender={this.createNewFormElementRelatedForm}
        size="large"
        notFoundContent={null}
        loading={this.props.loading}
        allowClear
        onSelect={this.onSelectOption(this.selectFormRef.current)}
        ref={this.selectFormRef}
      >
        {this.optionRender(listSelection)}
      </Select>
    );
  };

  _renderBillerType = () => {
    const optionBillerType = [
      { id: 'fixed', name: 'Fixed Bank Code' },
      { id: 'flexible', name: 'Flexible Bank Code' },
    ];
    const listSelection = optionBillerType.map(item => ({
      value: item.id,
      name: item.name,
    }));
    return (
      <Select
        showSearch
        placeholder="Choose Biller Type"
        optionFilterProp="children"
        filterOption={this.selectionFilter}
        size="large"
        onChange={this.onActionBillerType}
      >
        {this.optionRender(listSelection)}
      </Select>
    );
  };

  _renderListBankCode = () => {
    const listSelection = _.get(this.props, 'listBank', []).map(item => ({
      value: item.bank_id,
      name: `
      ${item.bank_code} - ${item.name}`,
    }));
    return (
      <Select
        showSearch
        placeholder="Search by bank name"
        optionFilterProp="children"
        filterOption={this.selectionFilter}
        size="large"
        disabled={this.showBeneficiaryBank()}
        loading={this.props.loading}
      >
        {this.optionRender(listSelection)}
      </Select>
    );
  };

  onActionBillerType = value => {
    const { billerDetail } = this.state;
    const newState = { ...billerDetail };
    newState.biller_type = value;
    this.setState({
      billerDetail: newState,
    });
  };

  optionRender = listSelection => {
    const listOption = [...listSelection];
    return listOption.map((item, index) => (
      <Option key={`${index + 1}-${item.value}`} value={item.value}>
        {item.name}
      </Option>
    ));
  };

  customValidation = (_rule, value, callback) => {
    const amount = parseInt(reformatNum(value), 10);
    const {
      intl: { formatMessage },
    } = this.props;

    if (value && amount > 50000) {
      callback(formatMessage(text.errorTransactionFee));
    } else {
      callback();
    }
  };

  _renderLeftForm = () => {
    const { billerDetail } = this.state;
    const {
      form: { getFieldDecorator },
      formType,
      listTnc,
    } = this.props;
    return (
      <div className="gutter-box">
        <Form.Item label="Billers Name" required colon={false}>
          {getFieldDecorator('biller_name', {
            initialValue: billerDetail.name,
            rules: [
              {
                required: true,
                message: 'Please fill this field',
              },
              {
                max: 50,
                message: 'Maximum 50 Character',
              },
            ],
          })(<Input placeholder="Enter Biller Name" size="large" />)}
        </Form.Item>

        {formType === 'edit' && (
          <Form.Item label="BillerURL" required colon={false}>
            {getFieldDecorator('biller_url', {
              initialValue: _.get(billerDetail, 'page_url', ''),
            })(
              <TextArea
                rows={2}
                disabled
                style={{ resize: 'none', padding: '10px' }}
              />,
            )}
          </Form.Item>
        )}

        <Form.Item
          label="Biller Icon"
          extra="File format only .png with resolution of 192px x 192px and maximum size of 100kb"
          required
          colon={false}
        >
          {getFieldDecorator('serviceIcon', {
            initialValue: billerDetail.icon_abs_url,
            rules: [
              {
                required: true,
                message: 'Biller icon is required',
              },
            ],
          })(this._renderServiceIconUpload())}
        </Form.Item>

        {formType === 'edit' && (
          <Form.Item label="IconURL" required colon={false}>
            {getFieldDecorator('service_icon_url', {
              initialValue: billerDetail.icon_abs_url,
            })(
              <TextArea
                rows={2}
                disabled
                style={{ resize: 'none', padding: '10px' }}
              />,
            )}
          </Form.Item>
        )}

        <Form.Item
          label="Biller Banner"
          extra="File format only .png with resolution of 375px x 96px and maximum size of 100kb"
          colon={false}
        >
          {getFieldDecorator('serviceBanner', {
            initialValue: billerDetail.banner_abs_url,
          })(this._renderServiceBannerUpload())}
        </Form.Item>
        <Form.Item
          colon={false}
          label="Terms & Conditions"
          extra="Terms & condition configuration per biller is available in create or update biller page"
        >
          {getFieldDecorator('tnc', {
            initialValue: get(billerDetail, 'tnc.public_id'),
          })(
            <Select
              showSearch
              size="large"
              className="search-default-form"
              placeholder="Assign Terms & Conditions"
              // suffixIcon={<Icon type="DownOutlined" />}
              notFoundContent={null}
              onSearch={this.handleSearch('tnc')}
              onFocus={() => {
                this.handleSearch('tnc')('');
              }}
              filterOption={this.selectionFilter}
              onSelect={this.onSelectOption(this.selectTnCRef.current)}
              ref={this.selectTnCRef}
              allowClear
            >
              {listTnc.map(tnc => (
                <Option
                  key={tnc.public_id}
                  value={tnc.public_id}
                  label={tnc.name}
                >
                  {`${tnc.public_id} - ${tnc.name}`}
                </Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item label="Playground Status" required colon={false}>
          {getFieldDecorator('playground_status', {
            initialValue: billerDetail.pground_status,
            setFieldsValue: billerDetail.pground_status,
          })(this._renderRadioPlayGroundStatus(billerDetail.pground_status))}
        </Form.Item>

        <Form.Item label="Skywallker Status" required colon={false}>
          {getFieldDecorator('skywallker_status', {
            initialValue: billerDetail.skyw_status,
            setFieldsValue: billerDetail.skyw_status,
          })(this._renderRadioSkyWallkerStatus(billerDetail.skyw_status))}
        </Form.Item>
      </div>
    );
  };

  renderBoldLabel = (value = '') => (label = '') => {
    const index = label.toLowerCase().indexOf(value.toLowerCase());
    if (index !== -1) {
      const { length } = value;
      const prefix = label.substring(0, index);
      const suffix = label.substring(index + length);
      const match = label.substring(index, index + length);
      return (
        <span>
          {prefix}
          <span className="search-form">{match}</span>
          {suffix}
        </span>
      );
    }

    return <span>{label}</span>;
  };

  renderLabel = value => item => {
    const publicId = item.public_id;
    let formName = item.name;
    if (value) {
      formName = this.renderBoldLabel(value)(formName);
    }

    return (
      <span>
        {publicId} - {formName}
      </span>
    );
  };
  _onChangeCheckboxPaymentMethod = selectedPaymentMethod => {
    this.selectedPaymentMethod = selectedPaymentMethod;
  };

  _renderPaymentMethodCheckbox = () => {
    const { listPaymentMethod, blacklistPaymentMethodInBillers } = this.props;
    const publicId = get(this.state, 'billerDetail.public_id', '');
    const isDisabled = (paymentMethodId = '') =>
      get(blacklistPaymentMethodInBillers, `${paymentMethodId}`, []).indexOf(
        publicId,
      ) >= 0;
    return (
      <Checkbox.Group onChange={this._onChangeCheckboxPaymentMethod}>
        <Row>
          {listPaymentMethod.map(paymentMethod => (
            <Col span={12} key={paymentMethod.id}>
              <Checkbox
                value={paymentMethod.id}
                defaultChecked
                disabled={isDisabled(paymentMethod.id)}
              >
                {paymentMethod.label}
              </Checkbox>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
    );
  };

  _renderRightForm = () => {
    const { billerDetail } = this.state;
    const {
      formType,
      form: { getFieldDecorator },
    } = this.props;

    const isEdit = formType === 'edit';
    return (
      <div className="gutter-box">
        <Form.Item label="Biller Type" required colon={false}>
          {getFieldDecorator('biller_type', {
            initialValue: isEdit
              ? _.get(billerDetail, 'biller_type', '')
              : undefined,
            rules: [{ required: true, message: 'Biller Type is required' }],
          })(this._renderBillerType())}
        </Form.Item>
        <Form.Item label="Service Name" required colon={false}>
          {getFieldDecorator('service_id', {
            initialValue: isEdit
              ? _.get(billerDetail, 'service.id', '')
              : undefined,
            rules: [{ required: true, message: 'Service Name is required' }],
          })(this._renderServiceList())}
        </Form.Item>

        <Form.Item
          label="Payment Method"
          required
          colon={false}
          extra="You can set more than 1  payment method listed above"
        >
          {getFieldDecorator('payment_method', {
            initialValue: _.get(billerDetail, 'payment_method', []),
            rules: [{ required: true, message: 'Payment Method is required' }],
          })(this._renderPaymentMethodCheckbox())}
        </Form.Item>

        <Form.Item
          colon={false}
          label="Transaction Fee"
          extra="If remain empty, transaction fee will refer to the values available in the related service"
        >
          {getFieldDecorator('transactionFee', {
            getValueFromEvent: amountInput,
            initialValue: _.get(billerDetail, 'transaction_fee')
              ? formatMoney(_.get(billerDetail, 'transaction_fee', ''))
              : '',
            rules: [
              {
                validator: this.customValidation,
              },
            ],
          })(<Input placeholder="ex. 5.000 (in IDR)" size="large" />)}
        </Form.Item>

        <Form.Item label="Related Form" colon={false}>
          {getFieldDecorator('related_form', {
            initialValue: isEdit
              ? _.get(billerDetail, 'form.id', '')
              : undefined,
          })(this._renderSearchRelatedForm())}
        </Form.Item>

        <Form.Item label="Beneficiary Bank Code" colon={false}>
          {getFieldDecorator('bank_id', {
            initialValue: _.get(billerDetail, 'beneficiary_bank.id', ''),
            rules: [
              {
                required: !this.showBeneficiaryBank(),
                message: 'Beneficiary Bank Code is required',
              },
            ],
          })(this._renderListBankCode())}
        </Form.Item>

        {this._renderCreatedAndUpdatedDate(
          billerDetail.created_at,
          billerDetail.updated_at,
          formType,
        )}
      </div>
    );
  };

  onActionValidateFields = formType => (err, values) => {
    if (!err) {
      switch (formType) {
        case 'edit':
          this.billerEditSubmit(values);
          break;
        default:
          this.billerAddSubmit(values);
      }
    }
  };

  _submitForm = e => {
    e.preventDefault();
    // Destruct Type Form
    const { formType } = this.props;
    // Form Validation
    this.props.form.validateFields(this.onActionValidateFields(formType));
  };

  _handleSyncConsent = isSync => () => {
    const { formType } = this.props;
    this.setState({ syncConsent: isSync }, () => {
      this.props.form.validateFields(this.onActionValidateFields(formType));

      if (this.state.proceedArchive) {
        this._onArchive();
      }
    });
  };

  renderModalSyncConsent = () => {
    const { syncModalVisible } = this.state;

    return (
      <Modal
        title="Confirmation"
        visible={syncModalVisible}
        footer={null}
        closable={false}
        className="modal-confirmation"
      >
        <center>
          Would you like this Biller to be available in{' '}
          <b>DANA Global Search?</b>
        </center>
        <center>
          If this Biller is still whitelisted, please choose <b>No</b>
        </center>

        <center className="btn-group-change">
          <Button
            className="btn-cancel"
            onClick={this._handleSyncConsent(false)}
          >
            No
          </Button>
          <Button
            className="btn-change"
            type="primary"
            onClick={this._handleSyncConsent(true)}
          >
            Yes
          </Button>
        </center>
      </Modal>
    );
  };

  render() {
    const {
      intl: { formatMessage },
      cancelSubmit,
      loading,
    } = this.props;
    return (
      <div className="biller-form">
        <Form onSubmit={this._submitForm}>
          <Row gutter={24}>
            <Col className="gutter-row" span={12}>
              {this._renderLeftForm()}
            </Col>
            <Col className="gutter-row" span={12}>
              {this._renderRightForm()}
            </Col>
          </Row>

          <Row type="flex" align="middle">
            <div style={{ width: 300, display: 'flex' }}>
              <Button
                type="primary"
                block
                htmlType="submit"
                className="submit-button"
                loading={loading}
              >
                Save
              </Button>
              <Button
                type="primary"
                block
                onClick={cancelSubmit}
                className="submit-button ml-5"
              >
                Cancel
              </Button>
            </div>
            <div>
              <p className="ml-10">
                <i>(*) {formatMessage(text.billerFormMandatory)}</i>
              </p>
            </div>
            {this._renderModalPreviewBanner()}
          </Row>
        </Form>
        <ModalConfirmation {...this.state.modalConfirm} />
        {this.renderModalSyncConsent()}
      </div>
    );
  }
}

FormBillerCreate.propTypes = {
  form: PropTypes.object,
  intl: PropTypes.object.isRequired,
  formValue: PropTypes.object,
  billerDetail: PropTypes.object,
  formType: PropTypes.string.isRequired,
  listForm: PropTypes.array,
  listService: PropTypes.array,
  listBank: PropTypes.array,
  onSubmit: PropTypes.func,
  listTnc: PropTypes.array,
  onArchive: PropTypes.func,
  billerUpdate: PropTypes.func,
  loading: PropTypes.bool,
  cancelSubmit: PropTypes.func,
  getListService: PropTypes.func,
  getListForm: PropTypes.func,
  biller: PropTypes.object,
  getListTnc: PropTypes.func,
  listPaymentMethod: PropTypes.array,
  blacklistPaymentMethodInBillers: PropTypes.object,
};

export default FormBillerCreate;
